import { useState } from "react";
import { getImage } from "../../utils/utility-functions";

// The same blank/generic avatar every assessment already falls back to
// when getImage() is given no group/name (its own internal
// isShowBlankImage branch — see utility-functions.js) — the existing,
// already-working default, not a new asset.
const DEFAULT_FALLBACK_SRC = getImage("", "", true);

// Same per-src failure semantics as DashboardAssessmentImage
// (src/components/assessment-overview/dashboard-assessment-image.js):
// failure is keyed to the specific `src` that failed, not a plain
// boolean, so switching to a different assessment/result (a new `src`)
// always gets a fresh attempt instead of staying stuck on the fallback.
//
// Unlike DashboardAssessmentImage, the fallback here is itself a hosted
// image — getImage()'s own "unknown-*-cir.svg" CDN default — rather than
// an inline SVG, since product asked to reuse the existing default
// profile asset instead of inventing a new one.
export default function ResultProfileImage({
  src,
  fallbackSrc = DEFAULT_FALLBACK_SRC,
  alt = "",
  className,
  id,
}) {
  const [erroredSrc, setErroredSrc] = useState(null);
  const usingFallback = !src || src === erroredSrc;
  const effectiveSrc = usingFallback ? fallbackSrc : src;

  return (
    <img
      id={id}
      src={effectiveSrc}
      alt={alt}
      className={className}
      onError={() => {
        // Only remember a failure for the specific result-image src we
        // actually attempted. If the fallback itself ever fails to load
        // too, do nothing further — never loop back into re-attempting
        // (and re-failing) the same fallback forever.
        if (!usingFallback) setErroredSrc(src);
      }}
    />
  );
}
